import * as React from 'react';
import { FicheringCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { useSelector } from 'react-redux';
import { getGaLabel, getNewbuildingId, getBuilders, getSellers } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { Context } from '../../utils/withApplicationContext';
import { trackOpenContacts, trackShowPhone } from './tracking';

export const Call = () => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel);
    setUserOpenedPhoneInNewobject(newbuildingId);
  }, [gaLabel, newbuildingId]);

  const context = React.useContext(Context);

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'blockFicheringMainScreen';

  return (
    <FicheringCall
      builders={builders}
      sellers={sellers}
      onOpenContactsClick={() => trackOpenContacts(gaLabel)}
      onShowPhoneClick={onShowPhoneClick}
      httpApi={/* istanbul ignore next */ context?.httpApi as IHttpApi}
      logger={/* istanbul ignore next */ context?.logger as ILogger}
      pageType={pageType}
      platformType={platformType}
      placeType={placeType}
    />
  );
};

Call.displayName = 'Call';
